import React from 'react';
import PropTypes from 'prop-types';
import { RowItem, ChartRow } from '../ChartRowAndHeader.styles';
import { TextSmall } from '../../../common/text';
import { Logger } from 'common/logger';

//ReleaseRowBase
export const MaintenanceChartRow = ({ data, ...props }) => {
    if (!data || !data.turbineData) {
        Logger.log('No data for ReleaseRow');
        return null;
    }
    const turbine = data.turbineData;
    return (
        <ChartRow>
            <RowItem width={100}>
                <TextSmall bold>{data.key}</TextSmall>
            </RowItem>
            <RowItem flex={1}>
                <TextSmall bold>{turbine.awp_nr}</TextSmall>
            </RowItem>
            <RowItem width={75}>
                <TextSmall bold>{turbine.turbineKey}</TextSmall>
            </RowItem>
        </ChartRow>
    );
};

MaintenanceChartRow.displayName = 'MaintenanceChartRow';

MaintenanceChartRow.propTypes = {
    data: PropTypes.object,
};
